<template>

    <div>
        <Row :gutter="16">
            <Col span="24">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row>
                        <Col>
                            <Form :model="postInfomation" :label-width="80" label-position="right">
                                <FormItem :label="t.post.name" prop="name">
                                    <Input v-model="postInfomation.name" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.post.code" prop="code">
                                    <Input v-model="postInfomation.code" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.post.sortOrder" prop="sortOrder">
                                    <Input v-model="postInfomation.sortOrder" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.post.status" prop="status">
                                    <Input v-model="postInfomation.status" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.post.createBy" prop="createBy">
                                    <Input v-model="postInfomation.createBy" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.post.createTime" prop="createTime">
                                    <Input v-model="postInfomation.createTime" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.post.updateBy" prop="updateBy">
                                    <Input v-model="postInfomation.updateBy" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.post.updateTime" prop="updateTime">
                                    <Input v-model="postInfomation.updateTime" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.post.remark" prop="remark">
                                    <Input v-model="postInfomation.remark" type="textarea"
                                           :autosize="{minRows: 3,maxRows: 3}" readonly></Input>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>
<script>
import { getPostInfo } from '@/api/post';

export default {
    name: 'organization_post_detail',
    data() {
        const t = this.$_t();
        return {
            self: this,
            t: t,
            postInfomation: {
                name: '',
                sortOrder: 0,
                status: '',
                createBy: '',
                createTime: '',
                updateBy: '',
                updateTime: '',
                remark: '',
            },
        };
    },
    methods: {
        async init() {
            const postInfo = await getPostInfo(this.$route.params.id);
            this.postInfomation = postInfo.post;
            //状态判断
            if (postInfo.post.status === '0') {
                this.postInfomation.status = this.t.post.close;
            } else if (postInfo.post.status === '1') {
                this.postInfomation.status = this.t.post.open;
            }
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" scoped>
</style>
